export const yearMonthFormat = 'YYYY-MM'
export const payoutDateFormat = 'MM.YYYY'
